import { Component } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'tech-core-quiz-quiz-cooldown',
  standalone: false,
  templateUrl: './quiz-cooldown.component.html',
  styleUrl: './quiz-cooldown.component.scss'
})
export class QuizCooldownComponent {

  constructor(
    private router: Router
  ) {
  }

  navigateToStart() {
    this.router.navigate(["/start"]);
  }

}
